import { render, staticRenderFns } from "./Stockchart_menu_mobile_bottom.vue?vue&type=template&id=32d9ea85&scoped=true&"
import script from "./Stockchart_menu_mobile_bottom.vue?vue&type=script&lang=js&"
export * from "./Stockchart_menu_mobile_bottom.vue?vue&type=script&lang=js&"
import style0 from "./Stockchart_menu_mobile_bottom.vue?vue&type=style&index=0&id=32d9ea85&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d9ea85",
  null
  
)

export default component.exports